import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import dayjs from "dayjs";

export default function EmergencyFormModal({ emerShow, setEmerShow }) {
  const navigate = useNavigate();

  const handleClose = () => {
    setEmerShow(false);
    navigate("/ClinicPatients");
  };

  const [dateValue, setDateValue] = useState(new Date());

  let stylez = `
  .sx-react-calendar-wrapper{
    width: 100%;
    max-height: 38rem;
  }

  .sx__view-selection{
    display: none;
  }



  .sx__week-grid__date-axis {
    padding-left: 1.5rem;
    display: flex;
}

.sx__week-grid__date
 {
    flex: unset;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: var(--sx-spacing-padding3) 0;
    gap: var(--sx-spacing-padding1);
}

.sx__view-container {        /* hides both scrollbars and scrolling */
  scrollbar-width: none;    /* hides scrollbar in Firefox */
  -ms-overflow-style: none; /* hides scrollbar in IE and Edge */
}

/* hides scrollbar in WebKit browsers like Chrome and Safari */
.sx__view-container::-webkit-scrollbar {
  display: none;
}

.sx__calendar{
  border: unset;
  border-radius: unset;
}

.cust-bg-tint{
  background-color: #8080800d;
}

.styled-label {
  font-size: .8rem;
  font-weight: 600;
  margin-bottom: .2rem;
  color: #6b6b6b;
}

input::placeholder {
  font-weight: 400;
  font-size: .8rem;
  opacity: 0.3;
  color: #adadad;
}

.rs-picker-toggle-placeholder {
  font-weight: 400;
  font-size: .8rem;
  color: #73717161 !important;
}

.rs-picker-popup.rs-picker-popup-date{
  z-Index : 10000;
}

.bdr-styled-container{
  border: 1px solid #8080804a;
  border-radius: 5px;
  min-height: 7rem;
}

.rs-input-group .rs-form-control-wrapper~.rs-input-group-addon, .rs-input-group input.rs-input~.rs-input-group-addon{
  color: #7eb18c;
  background-color: transparent;
}

.rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-indicator .rs-picker-caret-icon, .rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-indicator .rs-picker-clean{
  color: #7eb18c;
}

.rs-btn-ghost.rs-btn-active, .rs-btn-ghost:active {
  background-color: transparent;
  border-color: #004299;
  border-color: #7eb18c;
  color: #004299;
  color: #7eb18c;
}

.rs-btn-ghost:focus, .rs-btn-ghost:hover {
  background-color: transparent;
  border-color: #7eb18c;
  border-color: #7eb18c;
  -webkit-box-shadow: 0 0 0 1px #0a5dc2;
  -webkit-box-shadow: 0 0 0 1px var(--rs-btn-ghost-hover-border);
  box-shadow: 0 0 0 1px #0a5dc2;
  box-shadow: 0 0 0 1px #7eb18c;
  color: #7eb18c;
  color: #7eb18c;
}

.sx__week-grid__hour-text {
  color: #7eb18c;
}
.sx__week-grid__date--is-today .sx__week-grid__date-number{
  background-color: #7eb18c;
}

.sx__date-picker__day.sx__date-picker__day--today{
  background-color: #7eb18c;
}

.sx__date-picker__month-view-header__month-year:hover{
  color: #7eb18c;
}

.sx__date-picker__day.sx__date-picker__day--selected {
  background-color: #7eb18c6e;
  color: #fffefe;
}

.sx__date-input--active .sx__date-input {
  border-color: #7eb18c;
  outline: 1px solid #7eb18c;
}

.sx__date-input--active .sx__date-input-label{
  color: #7eb18c;
}

.sx__week-grid__date--is-today .sx__week-grid__day-name{
  color: #7eb18c;
}

.sx__is-calendar-small .sx__range-heading{
  color: #7eb18c;
}

.sx__time-grid-event{
  background-color: #d7f3df !important;
  color: #4a6d53 !important;
  border-top: 0px;
  border-inline-end: 0px;
  border-bottom: 0px;
  border-inline-start: 4px solid #4a6d53 !important;
}


.aptmnt-svbtn{
  background-color: transparent;
  border: 1px solid #7eb18c;
  color: #7eb18c;
}

.aptmnt-svbtn:hover{
  background-color: #7eb18c;
    color: white;
    border: 1px solid #7eb18c;
}

.rs-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  width : 100%;
}

.scrollable-dropdown .rs-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.custom-dropdown .rs-btn {
  background-color: #fff;
  border: 1px solid #e6e6eb;
  border-radius: 6px;
  height: 38px;
  font-size: 14px;
  color: #6c757d; /* placeholder-like color */
  padding-left: 12px;
  text-align: left;
  width: 100%;
  box-shadow: none;
}

.custom-dropdown .rs-btn:focus,
.custom-dropdown .rs-btn:active,
.custom-dropdown .rs-btn:hover {
  border-color: #86b7fe;
}

.custom-dropdown .rs-dropdown-toggle-caret {
  margin-left: auto;
}

  `;

  const [formData, setFormData] = useState({
    fullName: "",
    gender: "",
    dob: "",
    contactNumber: "",
    address: "",
    emergencyContactName: "",
    relationship: "",
    emergencyPhone: "",
    chiefComplaint: "",
    onsetTime: "",
    emergencyType: [],
    otherEmergencyType: "",
    temperature: "",
    pulse: "",
    bloodPressure: "",
    spo2: "",
    respiratoryRate: "",
    triageCategory: "",
    provisionalDiagnosis: "",
    consent: false,
    admissionDecision: "",
    referredTo: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "consent") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleEmergencyTypeChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFormData({
        ...formData,
        emergencyType: [...formData.emergencyType, value],
      });
    } else {
      setFormData({
        ...formData,
        emergencyType: formData.emergencyType.filter((type) => type !== value),
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    handleClose();
  };

  return (
    <>
      <style>{stylez}</style>
      <Modal
        show={emerShow}
        onHide={handleClose}
        size="lg"
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Emergency Patient Intake Form</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          
            {/* Patient Info */}
            <div className="row g-3">
              {/* Full Name */}
              <div className="col-md-4 col-12">
                <div className="input-block mb-2">
                  <label className="col-form-label lbl-VLJQLgvYMk">
                    Full Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    className="form-control"
                    placeholder="Enter Full Name"
                    style={{ height: "33px", borderRadius: "4px" }}
                  />
                </div>
              </div>

              {/* Gender */}
              <div className="col-md-4 col-12">
                <div
                  className="input-block mb-2"
                  style={{ position: "relative" }}
                >
                  <label className="col-form-label lbl-VLJQLgvYMk">
                    Gender
                  </label>
                  <div style={{ position: "relative" }}>
                    <select
                      className="form-control"
                      name="gender"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        paddingRight: "2.5rem",
                        height: "33px",
                        borderRadius: "4px",
                      }}
                    >
                      <option value="">Select the Options</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="others">Others</option>
                    </select>

                    {/* Dropdown Icon */}
                    <i
                      className="fa fa-caret-down"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#666",
                        fontSize: "1rem",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Date of Birth */}
              <div className="col-md-4 col-12 mt-4">
                <div className="input-block ">
                  <label className="mb-1" htmlFor="appointmentDate">
                    Date of Birth
                  </label>
                  <DatePicker
                    value={dateValue}
                    onChange={setDateValue}
                    format="dd-MMM-yyyy"
                    placeholder="dd-mmm-yyyy"
                    oneTap
                    style={{ width: "100%", height: "33px", borderRadius: "4px" }}
                  />
                </div>
              </div>
            </div>

            <div className="row g-3">
              {/* Contact Number */}
              <div className="col-md-4 col-12">
                <div className="input-block mb-2">
                  <label
                    htmlFor="contactNumber"
                    className="col-form-label lbl-VLJQLgvYMk"
                  >
                    Contact Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="contactNumber"
                    name="contactNumber"
                    className="form-control"
                    placeholder="Enter contact number"
                    style={{ height: "33px", borderRadius: "4px" }}
                  />
                </div>
              </div>

              {/* Address */}
              <div className="col-md-8 col-12">
                <div className="input-block mb-2">
                  <label
                    htmlFor="address"
                    className="col-form-label lbl-VLJQLgvYMk"
                  >
                    Address<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="address"
                    name="address"
                    className="form-control"
                    placeholder="Enter address"
                    style={{
                      height: "33px",
                      resize: "none",
                      overflow: "hidden",
                      borderRadius: "4px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Emergency Contact */}
            <h5 className="fw-bold my-1">Emergency Contact</h5>

            <div className="row g-1">
              {/* Contact Name */}
              <div className="col-md-4 col-12">
                <div className="input-block mb-2">
                  <label
                    htmlFor="emergencyContactName"
                    className="col-form-label lbl-VLJQLgvYMk"
                  >
                    Contact Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="emergencyContactName"
                    name="emergencyContactName"
                    placeholder="Enter contact name"
                    value={formData.emergencyContactName}
                    onChange={handleChange}
                    className="form-control"
                    style={{ height: "33px", borderRadius: "4px" }}
                  />
                </div>
              </div>

              {/* Relationship */}
              <div className="col-md-4 col-12">
                <div className="input-block mb-2">
                  <label
                    htmlFor="relationship"
                    className="col-form-label lbl-VLJQLgvYMk"
                  >
                    Relationship<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="relationship"
                    name="relationship"
                    placeholder="Enter relationship"
                    value={formData.relationship}
                    onChange={handleChange}
                    className="form-control"
                    style={{ height: "33px", borderRadius: "4px" }}
                  />
                </div>
              </div>

              {/* Phone Number */}
              <div className="col-md-4 col-12">
                <div className="input-block mb-2">
                  <label
                    htmlFor="emergencyPhone"
                    className="col-form-label lbl-VLJQLgvYMk"
                  >
                    Phone Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="emergencyPhone"
                    name="emergencyPhone"
                    placeholder="Enter phone number"
                    value={formData.emergencyPhone}
                    onChange={handleChange}
                    className="form-control"
                    style={{ height: "33px", borderRadius: "4px" }}
                  />
                </div>
              </div>
            </div>

            {/* Emergency Details */}
            <h5 className="fw-bold my-2">Emergency Details</h5>
            <div className="mb-2">
              <label htmlFor="chiefComplaint" className="form-label">
                Chief Complaint
              </label>
              <textarea
                id="chiefComplaint"
                name="chiefComplaint"
                placeholder="Enter chief complaint"
                value={formData.chiefComplaint}
                onChange={handleChange}
                className="form-control"
                rows={2}
              />
            </div>
            <div className="mb-3">
  <label htmlFor="onsetTime" className="form-label">
    Onset Time
  </label>
  <DatePicker
    id="onsetTime"
    name="onsetTime"
    value={formData.onsetTime ? new Date(formData.onsetTime) : null}
    onChange={(value) =>
      handleChange({
        target: {
          name: "onsetTime",
          value: dayjs(value).format("DD-MMM-YYYY hh:mm A"),
        },
      })
    }
    format="dd-MMM-yyyy hh:mm a"
    placeholder="Select date and time"
    showMeridian
    oneTap
    style={{ width: "100%" }}
  />
</div>

            <div className="mb-3">
              <label className="form-label">Type of Emergency</label>
              <div className="d-flex flex-wrap gap-3">
                {[
                  "Accident",
                  "Cardiac",
                  "Respiratory",
                  "Injury",
                  "Unconscious",
                  "Other"
                ].map((type) => (
                  <div key={type} className="form-check">
                    <input
                      type="checkbox"
                      value={type}
                      checked={formData.emergencyType.includes(type)}
                      onChange={handleEmergencyTypeChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label">{type}</label>
                  </div>
                ))}
                {/* <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    value="Other"
                    checked={formData.emergencyType.includes("Other")}
                    onChange={handleEmergencyTypeChange}
                    className="form-check-input"
                  />
                  <input
                    type="text"
                    name="otherEmergencyType"
                    placeholder="Specify other..."
                    value={formData.otherEmergencyType}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div> */}
              </div>
            </div>

            {/* Vitals */}
            <h5 className="fw-bold my-1">Vital Signs</h5>
            <div className="row g-3">
              {[
                { name: "temperature", label: "Temperature (°C)" },
                { name: "pulse", label: "Pulse (bpm)" },
                { name: "bloodPressure", label: "Blood Pressure" },
                { name: "spo2", label: "SpO₂ (%)" },
                { name: "respiratoryRate", label: "Respiratory Rate" },
              ].map(({ name, label }) => (
                <div key={name} className="col-md-4 col-12">
                  <div className="input-block ">
                    <label
                      htmlFor={name}
                      className="col-form-label lbl-VLJQLgvYMk"
                    >
                      {label}
                    </label>
                    <input
                      type="text"
                      id={name}
                      name={name}
                      placeholder={label}
                      value={formData[name]}
                      onChange={handleChange}
                      className="form-control"
                      style={{ height: "33px", borderRadius: "4px" }}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Triage */}
            <h5 className="fw-bold my-3">Triage Category</h5>
            <label className="form-label d-block">Select Category</label>
            <div className="d-flex flex-wrap gap-3 mb-3">
              {["Immediate", "Urgent", "Non-Urgent"].map(
                (cat) => (
                  <div key={cat} className="form-check">
                    <input
                      type="radio"
                      name="triageCategory"
                      value={cat}
                      checked={formData.triageCategory === cat}
                      onChange={handleChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label">{cat}</label>
                  </div>
                )
              )}
            </div>
            <div className="mb-4">
              <label htmlFor="provisionalDiagnosis" className="form-label">
                Provisional Diagnosis / Notes
              </label>
              <textarea
                id="provisionalDiagnosis"
                name="provisionalDiagnosis"
                placeholder="Enter provisional diagnosis or notes"
                value={formData.provisionalDiagnosis}
                onChange={handleChange}
                className="form-control"
                rows={2}
              />
            </div>

            {/* Consent & Admission */}
            <h5 className="fw-bold mb-2">Consent & Admission</h5>
            <div className="form-check mb-3">
              <input
                type="checkbox"
                name="consent"
                id="consent"
                checked={formData.consent}
                onChange={handleChange}
                className="form-check-input"
              />
              <label htmlFor="consent" className="form-check-label">
                Patient consents to emergency treatment
              </label>
            </div>

            <label className="form-label">Admission Decision</label>
            <div className="d-flex flex-column gap-2 mb-3">
              {[
                "Admission required",
                "Outpatient care sufficient",
                
              ].map((opt) => (
                <div key={opt} className="form-check">
                  <input
                    type="radio"
                    name="admissionDecision"
                    value={opt}
                    checked={formData.admissionDecision === opt}
                    onChange={handleChange}
                    className="form-check-input"
                  />
                  <label className="form-check-label">{opt}</label>
                </div>
              ))}
              
            </div>

            {/* Submit */}
            <div className="text-end mt-4">
              <Button type="submit" className="div-ButtonGreen" onClick={handleSubmit}>
                Submit
              </Button>
            </div>
          
        </Modal.Body>
      </Modal>
    </>
  );
}
